import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import Utils from '../../../../utils';
/**
 * Perform a new lookup into a specified datasource for a collection of nodes
 * @param {string} workspace
 * @param {string} dataSource
 * @param {string} xpath
 * @param {Array<string>} fields
 * @param {Array<{Name:string, Value:string}} parameters
 * @param {import('./types').LookupFilter} filter
 * @returns {Promise<import('./types').lookupApiResult>}
 */

var lookup = function lookup(workspace, dataSource, xpath, fields, parameters) {
  var filter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  var maxRowsStep = filter.maxRowsStep,
      startRowIdx = filter.startRowIdx,
      rest = _objectWithoutProperties(filter, ["maxRowsStep", "startRowIdx"]);

  return Utils.request({
    url: '/backend/formlookup',
    method: 'POST',
    contentType: 'auto',
    data: _objectSpread({
      WorkspaceName: workspace,
      dataSourcePath: dataSource,
      bindingsXPath: xpath,
      bindingMapFields: fields,
      dasParameters: parameters,
      maxRowsStep: maxRowsStep || 2147483647,
      startRowIdx: startRowIdx || 0
    }, rest)
  });
};

export default {
  lookup: lookup
};